<template>
  <div>
    <a-button id="create-strategy" type="primary" class="btn-modal" @click="handleShowModal">
      Crear nueva estrategia
    </a-button>

    <a-modal
      v-model:visible="visible"
      centered
      width="660px"
      title="Crear nueva estrategia"
      wrapClassName="create-strategy-modal"
      :footer="false"
      :okButtonProps="{ id: 'strategy-continue-button' }"
      :mask-closable="false"
      :keyboard="false"
    >
      <div class="modal__body">
        <p>Elige el enfoque de estrategia que mejor se adapte a tus necesidades:</p>

        <section class="cards">
          <div class="card" :class="getClass(1)" @click="handleClick(1)">
            <img class="card__icon" :src="filterImage" alt="filter" />
            <span class="card__title">Estrategia por filtros</span>
            <p class="card__description">
              Define estrategias utilizando los datos de tu base de contactos en {{ CompanyName }}, 
              aprovechando filtros prediseñados y personalizados para segmentar eficazmente.
            </p>
          </div>

          <div class="card" :class="getClass(2)" @click="handleClick(2)">
            <img class="card__icon" :src="clipboardImage" alt="clipboard" />
            <span class="card__title">Estrategia por plantilla</span>
            <p class="card__description">
              Diseña estrategias basadas en datos importados y utiliza nuestras plantillas predefinidas, 
              adaptadas según el tipo de estrategia, para una ejecución ágil y eficiente.
            </p>
          </div>
        </section>

        <span>
          Para conocer más de los tipos de estrategias,
          <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> visita nuestro docs. </a>
        </span>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { templateLink } from "@/app/shared/utils/url";
import { CompanyName } from "@/app/shared/utils/constants";

import filterImage from "@/app/strategies/assets/icon_filter.svg?url";
import clipboardImage from "@/app/strategies/assets/icon_clipboard.svg?url";

export default {
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/estrategias-1/`;

    return {
      visible: false,
      selected: 0,
      templateLink,
      DOCS_URL,
      CompanyName,
      filterImage,
      clipboardImage,
    };
  },
  methods: {
    handleOk() {
      const page = this.selected == 1 ? "filter" : "template";
      this.$router.push(`/strategies/${page}`);
    },
    handleShowModal() {
      this.selected = 0;
      this.visible = true;
    },
    getClass(type) {
      return { "card--selected": this.selected == type };
    },
    handleClick(type) {
      this.selected = type;
      this.handleOk();
    },
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    padding-top: 16px
    display: flex
    flex-direction: column
    align-items: center

.cards
  display: flex
  margin-bottom: 12px
  margin-top: 8px

.card
  margin: 10px
  padding: 12px 18px
  color: $gray-8
  border-radius: 8px
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)
  max-width: 170px
  display: flex
  flex-direction: column
  align-items: center
  cursor: pointer
  box-sizing: content-box
  transition: box-shadow 0.3s

  &:hover
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1)
    transition: box-shadow 0.3s

  &--selected
    border: 1px solid $blue-6
    margin: 9px

  &__icon
    display: block
    height: 60px
    margin: 8px 10px 18px 10px

  &__title
    font-weight: 600
    margin-bottom: 8px

  &__description
    font-size: 12px
    text-align: center
</style>
